import Gleap from 'gleap'
import type { User } from '~/shared/user/user.supabase.schema'
import { BUILD_VERSION } from './build-info'

export function initGleap() {
  const apiKey = import.meta.env.VITE_GLEAP_API_KEY

  if (typeof window !== 'undefined' && apiKey) {
    Gleap.initialize(apiKey)
  }
}

export function identifyGleapUser(userDetail: User | null) {
  const gleapInstance = Gleap.getInstance()
  if (!gleapInstance) return

  if (userDetail) {
    const sub = userDetail.active_entity?.customer_subscription

    Gleap.identify(String(userDetail.id), {
      name: [userDetail.first_name, userDetail.last_name].filter(Boolean).join(' '),
      email: userDetail.email ?? undefined,
      phone: userDetail.mobile_phone ?? userDetail.office_phone ?? undefined,
      companyId: userDetail.active_entity?.id != null ? String(userDetail.active_entity.id) : undefined,
      companyName: userDetail.active_entity?.name ?? undefined,
      plan: sub ? (Array.isArray(sub) ? sub[0]?.plan : sub.plan) : undefined,
      customData: {
        buildVersion: BUILD_VERSION,
      },
    })
  } else {
    Gleap.clearIdentity()
  }
}
